import React from 'react';
import { Spacer } from '@ontruck/orc';

import FormattedDate from 'redux/modules/log/renderer/shipperOrderRenderer/utils/FormattedDate';

const xDockStopUpdateRenderer = (props) => {
  const changes = props.changes;
  return (
    <div>
      <Spacer mBottom="XS">
        <span>{`Time window at ${changes.cross_dock}: `}</span>
        <span>
          <FormattedDate
            timeFrom={changes.previous_time_from}
            timeTo={changes.previous_time_to}
            tzFrom={changes.timezone}
            tzTo={changes.timezone}
          />
        </span>
        <> &#8594; </>
        <span>
          <FormattedDate
            timeFrom={changes.time_from}
            timeTo={changes.time_to}
            tzFrom={changes.timezone}
            tzTo={changes.timezone}
          />
        </span>
      </Spacer>
    </div>
  );
};

export default xDockStopUpdateRenderer;
